"use client";
import styles from './RadioGroup.module.css';
import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
    return (<RadioGroupPrimitive.Root className={`${styles.group} ${className || ''}`} {...props} ref={ref}/>);
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
    return (<RadioGroupPrimitive.Item ref={ref} className={`${styles.item} ${className || ''}`} {...props}>
      <RadioGroupPrimitive.Indicator className={styles.indicator}>
        <div className={styles.indicatorInner}/>
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>);
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
export { RadioGroup, RadioGroupItem };
